import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { T } from "../Translate";
import { auth, db } from "../../firebase"; // Make sure to configure your firebase file
import {
  collection,
  doc,
  getDocs,
  getDoc,
  query,
  where,
} from "firebase/firestore";
import {
  Button,
  TextField,
  Box,
  Grid,
  Container,
  AppBar,
  CardMedia,
  Toolbar,
  Typography,
  Skeleton,
  InputAdornment,
} from "@mui/material";
import { Search as SearchIcon } from "../../icons";
import { Flight as FlightIcon } from "../../icons";
import "react-date-picker/dist/DatePicker.css";
import Atras from "../BackButton";
import BottomNav from "../BottomToolbar";
import { pageHeaderInnerSx, pageContentSx } from "../../pageLayout";
import { brandColors, barColors } from "../../theme";

import SearchClearAdornment from "../../components/SearchClearAdornment";
const MyTrips = () => {
  const [places, setPlaces] = useState([]);
  // Arranca en true: el fetch inicial recién pone loading en true dentro del
  // efecto de mount, así que si arrancara en false se vería un flash de
  // contenido vacío antes del Skeleton.
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const isLoggedIn = () => {
    return !!auth.currentUser;
  };

  const getToken = async () => {
    if (auth.currentUser) {
      return auth.currentUser.getIdToken();
    }
    return null;
  };

  useEffect(() => {
    const checkAuthAndFetchPlaces = async () => {
      if (!isLoggedIn()) {
        navigate("/login");
        return;
      }

      try {
        const token = await getToken();
        if (!token) {
          console.error("No se pudo obtener el token de autenticación.");
          return;
        }

        const currentUser = auth.currentUser;
        if (!currentUser) {
          console.error("No hay un usuario autenticado.");
          return;
        }

        setLoading(true);
        const { uid } = currentUser;

        // Query the 'trips' collection for trips matching only the uid
        const tripsQuery = query(
          collection(db, "trips"),
          where("uid", "==", uid)
        );
        const tripsSnapshot = await getDocs(tripsQuery);

        const placePromises = tripsSnapshot.docs.map(async (tripDoc) => {
          const tripData = tripDoc.data();
          const placeRef = doc(db, "places", tripData.viajeId); // Assuming 'placeId' in 'trips' refers to the place ID
          const placeDoc = await getDoc(placeRef);

          if (placeDoc.exists()) {
            const placeData = placeDoc.data();
            let imageUrls = [];
            if (placeData.images && Array.isArray(placeData.images)) {
              imageUrls = placeData.images;
            } else if (
              placeData.images &&
              typeof placeData.images === "string"
            ) {
              imageUrls = [placeData.images];
            }
            return {
              ...placeData,
              imageUrls: imageUrls,
              createdAt: placeData.createdAt.toDate(),
            };
          } else {
            return null; // Or handle the case where the place is not found
          }
        });
              const placesData = await Promise.all(placePromises);
        setPlaces(placesData.filter((place) => place !== null)); // Filter out any null values

        setLoading(false);
      } catch (error) {
        console.error("Error al obtener places:", error);
        setLoading(false);
      }
    };

    checkAuthAndFetchPlaces();
  }, [navigate]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredPlaces = places.filter((place) => {
    const searchMatch =
      place.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      place.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      place.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
      place.price.toString().includes(searchTerm) ||
      place.place.toLowerCase().includes(searchTerm.toLowerCase());

    return searchMatch;
  });

  const formatDate = (timeToDo) => {
    if (timeToDo instanceof Date) {
      return timeToDo.toLocaleDateString();
    } else if (timeToDo && timeToDo.toDate instanceof Function) {
      return timeToDo.toDate().toLocaleDateString();
    }
    return "";
  };

  const handleVerClick = (placeId) => {
    navigate(`/trips/${placeId}`);
  };

  const styles = {
    cont: {
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      textAlign: "center",
      margin: 0,
      padding: 0,
      boxSizing: "border-box",
    },
    img: {
      maxWidth: "150px",
      maxHeight: "40px",
      display: "block",
      margin: "20px auto",
    },
    slogan: {
      color: "white",
      fontSize: "14px",
      fontWeight: "bold",
      paddingBottom: "-5px",
    },
    iconContainer: {
      display: "flex",
      width: "100%",
      borderTop: "1.5px solid black",
      justifyContent: "space-around",
      color: "black",
    },
    iconContainerL: {
      display: "flex",
      width: "100%",
      borderTop: "1.5px solid black",
      justifyContent: "space-around",
    },
    backSlogan: {
      display: "block",
      width: "100vw",
      height: "19px",
      backgroundColor: "#fff",
      textAlign: "center",
    },
    listItem: {
      display: "block",
      width: "95%",
      border: "0.5px solid #ccc",
      margin: "15px auto",
      boxShadow: "0px 0px 3px 0px black",
    },
    typography: {
      marginBottom: "0px",
    },
    contList: {
      marginTop: "-30px",
    },
    inputS: {
      width: "95%",
      height: "35px",
      marginTop: "20px",
      padding: "5px",
      fontSize: "14px",
      border: "3px solid grey",
      borderRadius: "4px",
    },
    card: {
      border: "2px solid grey",
      borderRadius: "10px",
      padding: "20px",
    },
    carde: {
      width: "100%",
      border: "1px solid #ddd",
      borderRadius: "8px",
      overflow: "hidden",
      marginBottom: "20px",
    },
    imageContainer: {
      position: "relative",
      width: "100%",
      height: "300px",
    },
    mainImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    additionalImagesOverlay: {
      position: "absolute",
      bottom: "10px",
      right: "10px",
      width: "80px",
      height: "80px",
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      color: "white",
      cursor: "pointer",
    },
    additionalImagesCount: {
      fontSize: "24px",
      fontWeight: "bold",
      color: "#ffffff",
    },
    contentContainer: {
      padding: "16px",
    },
    name: {
      fontSize: "14px",
      color: "#777",
      marginBottom: "8px",
    },
    title: {
      fontSize: "24px",
      fontWeight: "bold",
      marginBottom: "8px",
    },
    description: {
      fontSize: "14px",
      marginBottom: "8px",
    },
    price: {
      fontSize: "18px",
      fontWeight: "bold",
      color: "success.main",
      marginBottom: "8px",
    },
    place: {
      fontSize: "14px",
      color: brandColors.accent,
      marginBottom: "8px",
    },
    created: {
      fontSize: "12px",
      color: brandColors.textSecondary,
    },
    media: {
      width: "100px",
      marginTop: "15px",
      marginBottom: "15px",
    },
    imageGrid: {
      marginTop: "15px",
      marginBottom: "15px",
    },
    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    noImage: {
      width: "100%",
      height: "100px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: brandColors.backgroundDefault,
      color: brandColors.textSecondary,
    },
  };

  return (
    <Container>
      <AppBar position="fixed" sx={{ bgcolor: barColors.background, color: barColors.text }}>
        <Toolbar sx={{ padding: "10px 0" }}>
          <Box sx={pageHeaderInnerSx}>
            <Atras color="inherit" />
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
              <T>Mis Viajes</T>
            </Typography>
          </Box>
        </Toolbar>
        <Box sx={{ width: "100%", borderTop: `1px solid ${barColors.border}` }}>
          <Toolbar disableGutters sx={{ py: 1.5, px: 0 }}>
            <Box sx={pageHeaderInnerSx}>
              <TextField
                placeholder="Buscar en mis viajes..."
                value={searchTerm}
                onChange={handleSearchChange}
                variant="outlined"
                size="small"
                fullWidth
                InputProps={{
                  endAdornment: <SearchClearAdornment value={searchTerm} onChange={handleSearchChange} />,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: barColors.textMuted }} />
                    </InputAdornment>
                  ),
                  sx: {
                    color: barColors.text,
                    backgroundColor: barColors.activeBg,
                    borderRadius: "999px",
                    "& fieldset": { border: "none" },
                    "&:hover fieldset": { border: "none" },
                    "&.Mui-focused fieldset": { border: `1px solid ${barColors.border}` },
                  },
                }}
              />
            </Box>
          </Toolbar>
        </Box>
      </AppBar>
      <Container maxWidth={false} disableGutters sx={{ ...pageContentSx, mt: 23 }}>
        <Box>
          {loading ? (
            <Grid container spacing={2} sx={{ mb: 20 }}>
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <Grid item key={i} xs={12} sm={6} md={4} lg={4}>
                  <Box sx={{ p: 2, backgroundColor: brandColors.backgroundPaper, border: `1px solid ${brandColors.divider}`, borderRadius: "12px" }}>
                    <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: "8px", mb: 2 }} />
                    <Skeleton variant="text" width="80%" height={28} sx={{ mb: 1 }} />
                    <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
                    <Skeleton variant="text" width="60%" height={20} sx={{ mb: 1 }} />
                    <Skeleton variant="rectangular" width="100%" height={36} sx={{ borderRadius: "6px" }} />
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : (
            <>
              {filteredPlaces.length > 0 ? (
                <Grid container spacing={2} sx={{ mb: 20 }}>
                  {filteredPlaces.map((place) => (
                    <Grid item key={place.id} xs={12} sm={6} md={4} lg={4}>
                      <Box style={styles.card}>
                        <Typography style={styles.title}>
                          {place.title}
                        </Typography>

                        <Typography style={styles.description}>
                          {place.description}
                        </Typography>
                        <Typography style={styles.price}>
                          <T>Precio por día:</T> $ {place.price}
                        </Typography>
                        <Typography style={styles.place}>
                          <T>Ciudad:</T> {place.city}
                        </Typography>
                        <Typography style={styles.place}>
                          <T>Lugar:</T> {place.place}
                        </Typography>
                        <Typography style={styles.place}>
                          <T>Categoria:</T> {place.category}
                        </Typography>
                        <Box style={styles.imageContainer}>
                          {place.imageUrls && place.imageUrls.length > 0 ? (
                            <>
                              <CardMedia
                                component="img"
                                image={place.imageUrls[0]}
                                alt={`Imagen principal de ${place.name}`}
                                style={styles.mainImage}
                              />
                              {place.imageUrls.length > 1 && (
                                <Box style={styles.additionalImagesOverlay}>
                                  <Typography
                                    style={styles.additionalImagesCount}
                                  >
                                    +{place.imageUrls.length - 1}
                                  </Typography>
                                  <Typography sx={{ color: "#ffffff" }}><T>Ver más</T></Typography>
                                </Box>
                              )}
                            </>
                          ) : (
                            <Box style={styles.noImage}>
                              <Typography sx={{ color: "inherit" }}>
                                <T>No hay imágenes disponibles</T>
                              </Typography>
                            </Box>
                          )}
                        </Box>
                        <Button
                          variant="contained"
                          onClick={() => handleVerClick(place.id)}
                          fullWidth
                          sx={{ mt: 1, mb: 1 }}
                        >
                          <T>Volver a contactar</T>
                        </Button>
                        <Typography style={styles.created}>
                          <T>Fecha de publicación:</T> {formatDate(place.createdAt)}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    minHeight: "45vh",
                    gap: 1.5,
                    color: "text.secondary",
                  }}
                >
                  <FlightIcon sx={{ fontSize: 56, color: "text.disabled" }} />
                  <Typography sx={{ color: "text.secondary" }}>
                    <T>No se ha contratado ningún alojamiento aún.</T>
                  </Typography>
                </Box>
              )}
            </>
          )}
        </Box>
      </Container>
      <BottomNav />
    </Container>
  );
};

export default MyTrips;
